import React, { useState } from "react";
import ProfessionalModal from "./ProfessionalModal";
import { motion } from "framer-motion";

import ignacioImg from "../assets/professional/ignacio_farias.jpeg";
import estefaniaImg from "../assets/professional/estefania_bolado_v2.jpeg";
import julietaImg from "../assets/professional/julieta.jpeg";
import soledadImg from "../assets/professional/soledad.jpeg";
import franciscoImg from "../assets/professional/francisco.jpeg";
import ivanaImg from "../assets/professional/ivana.jpeg";
import fernandoImg from "../assets/professional/fernando.jpeg";
import salvadorImg from "../assets/professional/salvador.jpeg";
import macarenaImg from "../assets/professional/Macarena.jpeg";

// ------------------------------
// ANIMATIONS
// ------------------------------
const fadeUp = {
  initial: typeof window === "undefined" ? false : { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

const hoverLift = {
  hover: {
    y: -8,
    transition: { type: "spring", stiffness: 200, damping: 15 },
  },
};

// ------------------------------
// DATA
// ------------------------------
const professionalsData = [
  {
    id: "farias",
    name: "Ignacio Farías",
    position: "Socio Fundador y Director del Estudio",
    image: ignacioImg,
    contact: "ignaciofarias@fariaslegal.com.ar",
    phone: "(236) 4597021",
    estudio: "Abogado (UNLP, 1990–1994)",
     specialClass: "ignacio-img",   // 👈 agregamos clase especial
    description:
      "Fundó el Estudio en 1998, liderando su desarrollo con foco en el asesoramiento a empresas y grupos empresarios. Posee amplia trayectoria en derecho comercial, societario y concursal, especialmente en reestructuración de pasivos, conflictos societarios y planificación legal de negocios.",
  },
  {
    id: "ivana",
    name: "Ivana Medina",
    position: "Líder del Área Laboral",
    image: ivanaImg,
    contact: "ivanamedina@fariaslegal.com.ar",
    phone: "(236) 4507562",
    estudio: "Abogada (UNLP, 1998–2003). Especialista en Derecho Laboral",
    description:
      "Responsable del área de Derecho Laboral y Negociación Colectiva. Cuenta con amplia trayectoria en asesoramiento preventivo a empleadores, negociaciones paritarias y resolución de conflictos individuales del trabajo. Su práctica se centra en la gestión estratégica de relaciones laborales y en la prevención de contingencias empresariales.",
  },
  {
    id: "stefania",
    name: "Stefanía Bolado",
    position: "Líder del Área Societaria y Comercial",
    image: estefaniaImg,
    contact: "stefaniabolado@fariaslegal.com.ar",
    phone: "(236) 4552118",
    estudio: "Abogada (UBA, 2008–2013)",
    specialClass: "stefania-img",  
    description:
      "Responsable del área de Derecho Societario, Comercial, Concursal y Bancario. Posee experiencia en concursos preventivos, conflictos societarios,  régimen jurídico de los agronegocios,derecho bancario y contratos comerciales. Se destaca por su enfoque práctico, técnico y orientado a resultados, combinando análisis jurídico con visión estratégica empresarial.",
  },
  {
    id: "soledad",
    name: "Soledad Ferrari",
    position: "Abogada – Integrante del Área Laboral",
    image: soledadImg,
    contact: "soledadferrari@fariaslegal.com.ar",
    phone: "(236) 4558430",
    estudio: "Abogada (UBA, 2007–2012)",
    specialClass: "soledad-img",   // 👈 agregamos clase especial
    description:
      "Integra el equipo de Derecho Laboral y Negociación Colectiva, desarrollando tareas de asesoramiento preventivo a empleadores y gestión de conflictos laborales. Posee experiencia en relaciones individuales del trabajo, procedimientos administrativos y litigios laborales.",
  },
  {
    id: "francisco",
    name: "Francisco Sosa",
    position: "Abogado – Integrante del Área Laboral",
    image: franciscoImg,
    contact: "franciscososa@fariaslegal.com.ar",
    phone: "(2355) 489883",
    estudio: "Abogado (UNNOBA, 2020–2025)",
    specialClass: "francisco-img",
    description:
      "Forma parte del equipo de Derecho Laboral y Negociación Colectiva, participando en la gestión de conflictos individuales y en el asesoramiento a empleadores.",
  },
  {
    id: "julieta",
    name: "Julieta García",
    position: "Abogada – Integrante del Área Societaria y Comercial",
    image: julietaImg,
    contact: "julietagarcia@fariaslegal.com.ar",
    phone: "(236) 4557989",
    estudio: "Abogada (UNNOBA, 2016–2021)",
    description:
      "Integra el equipo de Derecho Societario y Comercial, colaborando en la redacción y ejecución de contratos, procesos judiciales bancarios e individuales. Cuenta con experiencia en ejecuciones de crédito y en asesoramiento preventivo a empresas.",
  },
  {
    id: "macarena-sosa",
    name: "Macarena Sosa",
    position: "Abogada – Integrante del Área Societaria y Comercial",
    image: macarenaImg,
    contact: "macarenasosa@fariaslegal.com.ar",
    phone: "(2355) 510329",
    estudio: "Abogada (UNNOBA, 2015–2022)",
    description:
      "Integra el equipo de Derecho Societario y Comercial, participando en la procuración y seguimiento integral de la cartera judicial del Estudio. Colabora en la gestión y control de expedientes, coordinación procesal y soporte operativo de litigios de índole civil y comerciales.",
  },
  {
    id: "salvador",
    name: "Salvador Bentorino",
    position: "Asistente Legal – Área Societaria y Comercial",
    image: salvadorImg,  
    contact: "salvadorbentorino@fariaslegal.com.ar",
    phone: "(236) 4227917",
    estudio: "Estudiante de Abogacía (UBA, desde 2021)",
    specialClass: "salvador-img",   // 👈 agregamos clase especial
    description:
      "Colabora en la preparación de contratos, procesos bancarios y concursos preventivos. Aporta apoyo técnico y organizativo en la gestión diaria del área, brindando soporte al equipo societario y comercial.",
  },
  {
    id: "fernando",
    name: "Fernando Farías",
    position: "Abogado – Colaborador en Derecho Penal",
    image: fernandoImg,
    contact: "estudiofarias.fernando@gmail.com",
    phone: "(236) 4505147",
    estudio: "Abogado (UNLP, 1990–1994)",
    specialClass: "fernando-img", 
    description:
      "Cuenta con amplia experiencia en Derecho Penal, especialmente en materias vinculadas a la actividad empresarial y económica. Su práctica se concentra en derecho penal de los negocios, delitos económicos y responsabilidad penal corporativa. Brinda colaboración permanente al Estudio en causas penales complejas.",
  },
];


// ------------------------------
// CARD COMPONENT
// ------------------------------
function ProfessionalCard({ p, delay, onClick }) {
  return (
    <motion.div
      key={p.id}
      className="bg-background rounded-xl shadow-md overflow-hidden cursor-pointer border border-transparent hover:border-accent transition"
      initial="initial"
      whileInView="animate"
      whileHover="hover"
      variants={{ ...fadeUp, ...hoverLift }}
      transition={{ delay, duration: 0.7 }}
      onClick={onClick}
    >
      <div className="h-64 overflow-hidden">
        <img src={p.image} alt={p.name}   className={`w-full h-full object-cover ${p.specialClass || ""}`} />
      </div>

      <div className="p-4 text-center">
        <h3 className="text-lg font-semibold text-primary">{p.name}</h3>
        <p className="text-sm text-gray-600">{p.position}</p>
      </div>
    </motion.div>
  );
}

// ------------------------------
// MAIN COMPONENT
// ------------------------------
export default function Professionals() {
  const [selected, setSelected] = useState(null);

  return (
    <section id="profesionales" className="py-20 md:py-24 bg-background">
      <motion.h2
        className="text-3xl md:text-4xl text-center font-semibold text-primary mb-8"
        initial="initial"
        whileInView="animate"
        variants={fadeUp}
        transition={{ duration: 0.7 }}
      >
        Nuestro Equipo
      </motion.h2>

      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {professionalsData.map((p, i) => (
          <ProfessionalCard
            key={p.id}
            p={p}
            delay={i * 0.12}
            onClick={() => setSelected(p)}
          />
        ))}
      </div>

      {selected && (
        <ProfessionalModal prof={selected} onClose={() => setSelected(null)} />
      )}
    </section>
  );
}
